import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  PostLogStatus,
  PostPlatform,
} from "../../../../shared/enums/campaignPost.enums";
import { BrandFacebookPostLog } from "../../../../shared/models/brandFacebookPostLog";
import { BrandGoogleAdPostLog } from "../../../../shared/models/brandGoogleAdPostLog";
import { BrandLinkedInPostLog } from "../../../../shared/models/brandLinkedInPostLog";
import { BrandService } from "../../../../shared/services/api/brand.service";
import { BrandCampaignPostsFiltersOrderBy } from "../../../../shared/services/filters/brand-campaign-post-filters-order-by";
import { HttpClient } from "../../../../shared/services/http-client";
import { BrandCampaignPostLogList } from "../../../../shared/services/responses/brand-campaign-post-log-list";

export interface PostLogsFilters {
  status?: PostLogStatus;
  facebookPosts?: boolean;
  googleAds?: boolean;
  facebookAds?: boolean;
  linkedinPosts?: boolean;
  partnerIds?: number[];
  orderBy?: BrandCampaignPostsFiltersOrderBy;
  startTime: number;
  endTime: number;
}

@Injectable()
export class BrandCampaignPostLogService {
  constructor(
    private readonly http: HttpClient,
    private readonly brandService: BrandService,
  ) {}

  public getBrandCampaignPostLogs(
    campaignId: number,
    filters: Partial<PostLogsFilters>,
    offset?: number,
    limit?: number,
  ): Observable<BrandCampaignPostLogList> {
    const brandId = this.brandService.currentBrandId;

    let url = `brand/${brandId}/campaign/${campaignId}/post_logs?x=1`;

    if (offset) {
      url = url + `&offset=${offset}`;
    }

    if (limit) {
      url = url + `&limit=${limit}`;
    }

    filters = Object.fromEntries(
      Object.entries(filters).filter(([, value]) => value !== undefined),
    );

    return this.http.put(url, filters).pipe(
      map(
        ({ body }) =>
          new BrandCampaignPostLogList(
            body.items.map((item: any) => {
              if (item.platform === PostPlatform.Facebook) {
                return new BrandFacebookPostLog(item);
              } else if (item.platform === PostPlatform.Google) {
                return new BrandGoogleAdPostLog(item);
              } else if (item.platform === PostPlatform.LinkedIn) {
                return new BrandLinkedInPostLog(item);
              }
            }),
            body._meta.totalCount,
            body._meta,
          ),
      ),
    );
  }
}
